import React from "react";
import {
    SkillContent,
    SkillTitle,
    SkillBox,
    SkillGroup,
    SkillData,
    SkillName,
    SkillLevel,
} from "./styles";

const Blockchain = () => {
    return (
        <SkillContent>
            <SkillTitle>Blockchain Developer</SkillTitle>

            <SkillBox>
                <SkillGroup>
                    <SkillData>
                        <i className="bx bx-badge-check"></i>
                        <div>
                            <SkillName>Solidity</SkillName>
                            <SkillLevel>Intermediate</SkillLevel>
                        </div>
                    </SkillData>

                    <SkillData>
                        <i className="bx bx-badge-check"></i>
                        <div>
                            <SkillName>EthersJS</SkillName>
                            <SkillLevel>Advanced</SkillLevel>
                        </div>
                    </SkillData>

                    <SkillData>
                        <i className="bx bx-badge-check"></i>
                        <div>
                            <SkillName>Web3JS</SkillName>
                            <SkillLevel>Advanced</SkillLevel>
                        </div>
                    </SkillData>
                </SkillGroup>

                <SkillGroup>
                    <SkillData>
                        <i className="bx bx-badge-check"></i>
                        <div>
                            <SkillName>Git</SkillName>
                            <SkillLevel>Advanced</SkillLevel>
                        </div>
                    </SkillData>

                    <SkillData>
                        <i className="bx bx-badge-check"></i>
                        <div>
                            <SkillName>Hardhat</SkillName>
                            <SkillLevel>Advanced</SkillLevel>
                        </div>
                    </SkillData>

                    <SkillData>
                        <i className="bx bx-badge-check"></i>
                        <div>
                            <SkillName>Foundary</SkillName>
                            <SkillLevel>Beginner</SkillLevel>
                        </div>
                    </SkillData>
                </SkillGroup>
            </SkillBox>
        </SkillContent>
    );
};

export default Blockchain;
